<template>
  <form @submit.stop.prevent="addDiscount">
    <div class="mt-5">
      <label>Discount Percentage</label>
      <input
          v-model="percentage"
          type="number"
          class="form-control"
          :class="{
              'is-invalid': v$.percentage.$error,
          }"
      />
      <p
          v-for="error of v$.percentage.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-3">
      <label>Discount Amount</label>
      <input
          v-model="amount"
          type="number"
          class="form-control"
          :class="{
              'is-invalid': v$.amount.$error,
          }"
      />
      <p
          v-for="error of v$.amount.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="sm" class="py-2" disabled v-if="ordersLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button :variant="button_color" size="sm" class="py-2 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {mapGetters} from "vuex";
export default {
name: "order-discount-modal-component",
  setup () {
    return { v$: useVuelidate() }
  },
  props:{
    button_text: {type: String},
    button_color: {type: String},
    discountItem: {
      type: Object,
      default(){
        return {
          percentage: '',
          amount: ''
        }
      }
    }
  },
  data(){
    return{
      percentage: this.discountItem.percentage,
      amount: this.discountItem.amount
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  validations () {
    return {
      percentage: {required},
      amount: {required},
    }
  },
  methods: {
    async addDiscount(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      this.v$.$touch();
      this.$emit('addDiscount', parseInt(this.percentage), parseInt(this.amount))
    }
  }
}
</script>

<style scoped>

</style>
